import React from 'react'
import { LeftSide, Title } from '../style'
import { CertificateType } from '..'
import SelectParamInCertificate from '../../../../../components/Certificates/SelectItem/Param'
import SelectSupplierInCertificate from '../../../../../components/Certificates/SelectItem/Supplier'
import SelectCustomerInCertificate from '../../../../../components/Certificates/SelectItem/Customer'

interface PropsType {
  certificate: CertificateType
  setCertificate: React.Dispatch<React.SetStateAction<CertificateType>>
}

const StructuringCertificateFields:React.FC<PropsType> = ({certificate, setCertificate}) => {  
  const structuringCompleted = certificate.param.id && certificate.customer.id && certificate.supplier.id ? true : false
  
  return (
    <LeftSide>
      <Title style={{marginBottom: '5px'}}>Estruturantes</Title>
      <SelectSupplierInCertificate certificate={certificate} setCertificate={setCertificate} structuringCompleted={structuringCompleted}/>
      <SelectCustomerInCertificate certificate={certificate} setCertificate={setCertificate} structuringCompleted={structuringCompleted}/>
      {/* <SelectCertificateTypeInCertificate certificate={certificate} setCertificate={setCertificate} /> */}
      <SelectParamInCertificate certificate={certificate} setCertificate={setCertificate} structuringCompleted={structuringCompleted}/>
    </LeftSide>
  )
}

export default StructuringCertificateFields